module.exports = __webpack_public_path__ + "static/media/autism_table.d2fb48fe.png";